import { useMemo } from 'react';
import { ITrendDataItem } from '../types';
import {
  INormalizedPeriods,
  IPeriodData,
} from '../helpers/normalizePeriodsToDate';

export default useHasNoData;

function useHasNoData(
  fulfilled: boolean,
  trends: INormalizedPeriods[]
): boolean {
  const hasNoData = useMemo(() => {
    if (!fulfilled) return false;
    if (!trends) return true;
    if (trends.length === 0) return true;
    return trends.every((trend) =>
      trend.data.every((d: IPeriodData | ITrendDataItem) => d.value === null)
    );
  }, [fulfilled, trends]);

  return hasNoData;
}
